import { Ellipsis } from "lucide-react";

export default {
  logo_bg: require("./logo.png"),
  hero: require("./heropage.png"),
  template: require("./Template-banner-img.png"),
  trophy: require("./trophy 1.png"),
  guarantee: require("./guarantee.png"),
  shipping: require("./shipping.png"),
  Vector: require("./Vector.png"),
  Footerlogo: require("./Footer-logo.png"),
  custamize: require("./custamize.png"),
  qright: require("./QR light.png"),
  doller: require("./doller.png"),
  frame1: require("./Frame1.png"),
  Template1: require("./Template-1.png"),
  Template2: require("./Template-2.png"),
  Template3: require("./Template-3.png"),
  Template4: require("./Template-4.png"),
  Template5: require("./Template-5.png"),
  Template6: require("./Template-6.png"),
  Template7: require("./Template-7.png"),
  Template8: require("./Template-8.png"),
  Template9: require("./Template-9.png"),
  Template10: require("./Template-10.png"),
  Template11: require("./Template-11.png"),
  Template12: require("./Template-12.png"),
  Template13: require("./Template-13.png"),
  Template14: require("./Template-14.png"),
  Template15: require("./Template-15.png"),
  Template16: require("./Template-16.png"),
  divide: require("./divide.png"),
  menucard: require("./Menucard.png"),
  women: require("./woman.png"),
  men: require("./men.png"),
  centercard: require("./center-card.png"),
  centercardimg1: require("./center-card-img1.png"),
  centercardimg2: require("./center-card-img2.png"),
  centercardimg3: require("./center-card-img3.png"),
  centercardimg4: require("./center-card-img4.png"),
  goal1: require("./goal1.png"),
  goal2: require("./goal2.png"),
  goal3: require("./goal3.png"),
  goal4: require("./goal4.png"),
  card1: require("./Card1.png"),
  card2: require("./Card2.png"),
  card3: require("./Card3.png"),
  card4: require("./Card4.png"),
  card5: require("./Card5.png"),
  card6: require("./Card6.png"),
  vector: require("./Vector 51.png"),
  qr: require("./qr.png"),
  phone: require("./phone.png"),
  location: require("./map-pin.png"),
  learn1: require("./learn1.png"),
  learn2: require("./learn2.png"),
  learn3: require("./learn3.png"),
  learn4: require("./learn4.png"),
  Ellipsistop: require("./Ellipsetop.png"),
  Ellipsisleft: require("./Ellipseleft.png"),
  qflyersMockup: require("./qflyersMockup.png"),
  app: require("./app.png"),
  play: require("./playstore.png"),
};
